<template>
<div class="kt-widget__media">
    <img ...img />
</div>
</template>

<script>
export default {
    props: {
        img: {
            type: Object,
            default: function() {
                return {
                    src: '',
                    alt: '',
                    name: '',
                }
            }
        }
    }
}
</script>